import { useState } from "react";
import { FIGURE_LABELS, getFigures, setFigures } from "@/lib/bodyRegions";

const Row = ({ label, keys, value, onPick, testId }) => (
  <div className="mt-4">
    <p className="text-[13px] text-[#A8998C]">{label}</p>
    <div role="radiogroup" aria-label={label} className="mt-2 flex flex-wrap gap-2">
      {keys.map((k) => (
        <button key={k} role="radio" aria-checked={value === k} data-testid={`${testId}-${k}`} onClick={() => onPick(k)}
          className={`rounded-full border px-4 py-2 text-[13px] transition-colors ${value === k ? "bg-[#D9B47A] border-[#D9B47A] text-[#0A0706]" : "border-[#D9B47A]/30 text-[#CFC2B6] hover:border-[#D9B47A]"}`}>{FIGURE_LABELS[k]}</button>
      ))}
    </div>
  </div>
);

// Settings: which figures the body and energy maps show by default (each practice can still switch on the spot).
export default function FigurePrefs() {
  const [p, setP] = useState(getFigures);
  const pick = (patch) => {
    setFigures(patch);
    setP((x) => ({ ...x, ...patch }));
  };
  return (
    <section data-testid="figure-prefs" className="mt-6 border border-[#D9B47A]/20 p-6">
      <p className="font-display text-xl">Body figures</p>
      <p className="mt-1 text-sm text-[#A8998C]">Shown when a practice moves energy through the body.</p>
      <Row label="Solo practice" keys={["female", "male"]} value={p.solo} onPick={(solo) => pick({ solo })} testId="figure-prefs-solo" />
      <Row label="Partner practice" keys={["fm", "mm", "ff"]} value={p.pair} onPick={(pair) => pick({ pair })} testId="figure-prefs-pair" />
    </section>
  );
}
